import React from "react";

const FileText = ({ width = "44px", height = "54px" }) => (
  <svg
    className="fill-current"
    width={width}
    height={height}
    viewBox="0 0 150 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.507 111.115C111.995 127.133 92.7519 139.693 81.5466 128.024C75.2494 122.603 72.8644 114.1 47.2242 117.02C36.8749 118.017 18.4355 117.364 16.3371 92.3413C15.9762 87.2266 16.8008 74.0571 30.7948 61.7112C35.0469 58.0827 48.1164 50.1755 38.1098 35.3008C32.2753 26.6681 39.8407 14.7297 62.9692 18.3458C73.6261 19.4912 162.233 32.6026 120.507 111.115"
      fill="#FFE29B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.0149 107.443C46.8105 107.443 45.8308 106.463 45.8308 105.259V37.0284C45.8308 35.8249 46.8105 34.8452 48.0149 34.8452H87.3292C87.9071 34.8452 88.4736 35.0794 88.883 35.4879L105.537 52.1421C105.952 52.5581 106.181 53.1104 106.181 53.6969V105.259C106.181 106.463 105.201 107.443 103.997 107.443H48.0149Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M87.3292 34.1702H48.015C46.4364 34.1702 45.1567 35.4498 45.1567 37.0284V105.259C45.1567 106.838 46.4364 108.117 48.015 108.117H103.998C105.576 108.117 106.856 106.838 106.856 105.259V53.6968C106.856 52.9342 106.552 52.2039 106.014 51.6651L89.361 35.0109C88.8211 34.4729 88.0909 34.1702 87.3292 34.1702M87.3292 35.5193C87.7358 35.5193 88.1185 35.6773 88.406 35.9658L105.06 52.62C105.348 52.9075 105.506 53.2903 105.506 53.6968V105.259C105.506 106.091 104.829 106.768 103.998 106.768H48.015C47.1828 106.768 46.5059 106.091 46.5059 105.259V37.0283C46.5059 36.1962 47.1828 35.5193 48.015 35.5193H87.3292"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.4461 17.6818C25.4461 17.6818 25.4461 17.7656 25.2795 17.8484C25.2795 17.8484 21.214 19.1842 18.2273 22.1043C15.3224 25.0244 13.9961 29.1965 13.9961 29.1965C13.9961 29.3641 13.8295 29.3641 13.8295 29.3641C13.8295 29.3641 13.7467 29.3641 13.6638 29.1965C13.6638 29.1965 12.3356 25.0244 9.43173 22.1043C6.52782 19.1842 2.37856 17.8484 2.37856 17.8484C2.21289 17.8484 2.21289 17.6818 2.21289 17.6818C2.21289 17.6818 2.21289 17.599 2.37856 17.5152C2.37856 17.5152 6.44499 16.1803 9.43173 13.2593C12.3356 10.3392 13.6638 6.16708 13.6638 6.16708C13.6638 5.99951 13.8295 5.99951 13.8295 5.99951C13.8295 5.99951 13.9961 5.99951 13.9961 6.16708C13.9961 6.16708 15.3224 10.3392 18.2273 13.2593C21.1312 16.1803 25.2795 17.5152 25.2795 17.5152C25.4461 17.599 25.4461 17.6818 25.4461 17.6818"
      fill="#FFCB05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.187 119.067C100.187 119.067 100.187 119.107 100.109 119.146C100.109 119.146 98.1858 119.778 96.7729 121.159C95.4 122.541 94.7716 124.513 94.7716 124.513C94.7716 124.592 94.6926 124.592 94.6926 124.592C94.6926 124.592 94.6535 124.592 94.6136 124.513C94.6136 124.513 93.9861 122.541 92.6132 121.159C91.2393 119.778 89.277 119.146 89.277 119.146C89.198 119.146 89.198 119.067 89.198 119.067C89.198 119.067 89.198 119.027 89.277 118.988C89.277 118.988 91.2003 118.357 92.6132 116.975C93.9861 115.594 94.6136 113.62 94.6136 113.62C94.6136 113.541 94.6926 113.541 94.6926 113.541C94.6926 113.541 94.7716 113.541 94.7716 113.62C94.7716 113.62 95.4 115.594 96.7729 116.975C98.1459 118.357 100.109 118.988 100.109 118.988C100.187 119.027 100.187 119.067 100.187 119.067"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.7915 90.9742C38.7915 90.9742 38.7915 91.0065 38.7267 91.0399C38.7267 91.0399 37.1339 91.5626 35.9618 92.707C34.8241 93.8514 34.3042 95.4871 34.3042 95.4871C34.3042 95.5528 34.2395 95.5528 34.2395 95.5528C34.2395 95.5528 34.2071 95.5528 34.1738 95.4871C34.1738 95.4871 33.6539 93.8514 32.5152 92.707C31.3775 91.5626 29.7513 91.0399 29.7513 91.0399C29.6865 91.0399 29.6865 90.9742 29.6865 90.9742C29.6865 90.9742 29.6865 90.9418 29.7513 90.9085C29.7513 90.9085 31.3451 90.3858 32.5152 89.2413C33.6539 88.096 34.1738 86.4612 34.1738 86.4612C34.1738 86.3955 34.2395 86.3955 34.2395 86.3955C34.2395 86.3955 34.3042 86.3955 34.3042 86.4612C34.3042 86.4612 34.8241 88.096 35.9618 89.2413C37.1015 90.3858 38.7267 90.9085 38.7267 90.9085C38.7915 90.9418 38.7915 90.9742 38.7915 90.9742"
      fill="#FFCB05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M63.0543 137.876C63.0543 137.876 63.0543 137.926 62.9553 137.975C62.9553 137.975 60.5265 138.773 58.7423 140.518C57.0066 142.263 56.2135 144.755 56.2135 144.755C56.2135 144.854 56.1145 144.854 56.1145 144.854C56.1145 144.854 56.065 144.854 56.0154 144.755C56.0154 144.755 55.2223 142.263 53.4876 140.518C51.7529 138.773 49.2746 137.975 49.2746 137.975C49.1755 137.975 49.1755 137.876 49.1755 137.876C49.1755 137.876 49.1755 137.827 49.2746 137.776C49.2746 137.776 51.7034 136.979 53.4876 135.234C55.2223 133.49 56.0154 130.997 56.0154 130.997C56.0154 130.897 56.1145 130.897 56.1145 130.897C56.1145 130.897 56.2135 130.897 56.2135 130.997C56.2135 130.997 57.0066 133.49 58.7423 135.234C60.477 136.979 62.9553 137.776 62.9553 137.776C63.0543 137.827 63.0543 137.876 63.0543 137.876"
      fill="#C00033"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.27539 91.5046C9.27539 91.5046 9.27539 91.5379 9.20874 91.5712C9.20874 91.5712 7.58636 92.1044 6.39337 93.2698C5.23371 94.4361 4.70339 96.1013 4.70339 96.1013C4.70339 96.168 4.63769 96.168 4.63769 96.168C4.63769 96.168 4.60437 96.168 4.572 96.1013C4.572 96.1013 4.04168 94.4361 2.88202 93.2698C1.72235 92.1044 0.0656951 91.5712 0.0656951 91.5712C0 91.5712 0 91.5046 0 91.5046C0 91.5046 0 91.4713 0.0656951 91.4379C0.0656951 91.4379 1.68903 90.9048 2.88202 89.7394C4.04168 88.5731 4.572 86.9078 4.572 86.9078C4.572 86.8412 4.63769 86.8412 4.63769 86.8412C4.63769 86.8412 4.70339 86.8412 4.70339 86.9078C4.70339 86.9078 5.23371 88.5731 6.39337 89.7394C7.55208 90.9048 9.20874 91.4379 9.20874 91.4379C9.27539 91.4713 9.27539 91.5046 9.27539 91.5046"
      fill="#C00033"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150 86.3955C150 86.3955 150 86.4422 149.907 86.4879C149.907 86.4879 147.658 87.2267 146.005 88.8434C144.397 90.4601 143.663 92.7689 143.663 92.7689C143.663 92.8613 143.57 92.8613 143.57 92.8613C143.57 92.8613 143.524 92.8613 143.478 92.7689C143.478 92.7689 142.744 90.4601 141.137 88.8434C139.529 87.2267 137.233 86.4879 137.233 86.4879C137.142 86.4879 137.142 86.3955 137.142 86.3955C137.142 86.3955 137.142 86.3498 137.233 86.3032C137.233 86.3032 139.483 85.5644 141.137 83.9477C142.744 82.332 143.478 80.0231 143.478 80.0231C143.478 79.9298 143.57 79.9298 143.57 79.9298C143.57 79.9298 143.663 79.9298 143.663 80.0231C143.663 80.0231 144.397 82.332 146.005 83.9477C147.612 85.5644 149.907 86.3032 149.907 86.3032C150 86.3498 150 86.3955 150 86.3955"
      fill="#C00033"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.0376 100.812C53.7951 100.812 52.7859 99.8007 52.7859 98.5592V30.3696C52.7859 29.1804 53.7523 28.214 54.9405 28.214H92.7228C94.3166 28.214 95.8152 28.8338 96.9416 29.9601L111.389 44.4074C112.515 45.5346 113.136 47.0333 113.136 48.6261V98.6563C113.136 99.8445 112.169 100.812 110.98 100.812H55.0376Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.7228 27.5391H54.9414C53.3781 27.5391 52.1108 28.8063 52.1108 30.3697V98.5593C52.1108 100.176 53.4209 101.486 55.0376 101.486H110.98C112.543 101.486 113.81 100.219 113.81 98.6564V48.6262C113.81 46.8648 113.111 45.1758 111.865 43.9305L97.4186 29.4833C96.1732 28.2379 94.4842 27.5391 92.7228 27.5391M92.7228 28.8881C94.1358 28.8881 95.4649 29.4384 96.4646 30.4372L110.912 44.8854C111.91 45.8841 112.46 47.2132 112.46 48.6262V98.6563C112.46 99.4723 111.796 100.137 110.98 100.137H55.0377C54.1684 100.137 53.46 99.4294 53.46 98.5592V30.3696C53.46 29.5527 54.1246 28.8881 54.9415 28.8881H92.7228"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.4941 28.001V43.7821C92.4941 46.228 94.4774 48.2113 96.9233 48.2113H113.006"
      fill="white"
    />
    <path
      d="M92.4941 28.001V43.7821C92.4941 46.228 94.4774 48.2113 96.9233 48.2113H113.006"
      stroke="black"
      strokeWidth="1.417"
    />
    <path
      d="M67.335 59.8999H103.02"
      stroke="black"
      strokeWidth="1.417"
      strokeLinecap="round"
    />
    <path
      d="M67.335 68.391H103.02"
      stroke="black"
      strokeWidth="1.417"
      strokeLinecap="round"
    />
    <path
      d="M67.335 76.8829H103.02"
      stroke="black"
      strokeWidth="1.417"
      strokeLinecap="round"
    />
    <path
      d="M67.335 85.374H84.7594"
      stroke="black"
      strokeWidth="1.417"
      strokeLinecap="round"
    />
    <path
      d="M67.335 44.6289H78.1299"
      stroke="black"
      strokeWidth="1.417"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M97.0463 47.5838H112.372C112.212 46.6165 111.769 45.7224 111.061 45.015L96.2999 30.2527C95.4468 29.4015 94.3262 28.9283 93.1284 28.8835V43.6659C93.1284 45.83 94.8831 47.5838 97.0463 47.5838"
      fill="#FFCB05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.5508 101.753H66.9756V99.2527H60.5508V101.753Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M87.7878 69.6415H94.2136V67.1422H87.7878V69.6415Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M87.7878 108.118H94.2136V105.618H87.7878V108.118Z"
      fill="white"
    />
  </svg>
);

export default FileText;
